import type { CandleWithFlag } from "features/chart";

export function calcParabolicSAR(
  data: CandleWithFlag[],
  acceleration: number,
  maxAcceleration: number,
): (number | null)[] {
  const n = data.length;
  const result: (number | null)[] = new Array(n).fill(null);
  if (n < 2) return result;

  let uptrend = data[1].close >= data[0].close;
  let sar = uptrend ? data[0].low : data[0].high;
  let ep = uptrend ? data[0].high : data[0].low;
  let af = acceleration;

  for (let i = 1; i < n; i++) {
    let newSar = sar + af * (ep - sar);

    if (uptrend) {
      newSar = Math.min(newSar, data[i - 1].low);
      if (i >= 2) newSar = Math.min(newSar, data[i - 2].low);

      if (data[i].low < newSar) {
        uptrend = false;
        newSar = ep;
        ep = data[i].low;
        af = acceleration;
      } else {
        if (data[i].high > ep) {
          ep = data[i].high;
          af = Math.min(af + acceleration, maxAcceleration);
        }
      }
    } else {
      newSar = Math.max(newSar, data[i - 1].high);
      if (i >= 2) newSar = Math.max(newSar, data[i - 2].high);

      if (data[i].high > newSar) {
        uptrend = true;
        newSar = ep;
        ep = data[i].high;
        af = acceleration;
      } else {
        if (data[i].low < ep) {
          ep = data[i].low;
          af = Math.min(af + acceleration, maxAcceleration);
        }
      }
    }

    sar = newSar;
    result[i] = sar;
  }

  return result;
}
